module.exports = __webpack_public_path__ + "static/media/ios-thumbs-up.beedc6b9.svg";